"use client";
import React, { useState, useEffect, useRef } from 'react';
import Link from 'next/link';
import DropdownLink from './dropDownLink';
import HomeIcon from '../icons/homeIcon';
import AboutIcon from '../icons/aboutIcon';
import CompIcon from '../icons/compIcon';
import FolderIcon from '../icons/folderIcon';
import ContactIcon from '../icons/contactIcon';

import '../icons/hamburgCrossStyles.css';
import BlogIcon from '../icons/blogIcon';
import SubscriptionIcon from '../icons/subscriptionicon';

const DropdownMenu: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const menuRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        menuRef.current &&
        buttonRef.current &&
        event.target instanceof Node &&
        !menuRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Cleanup the event listener when the component unmounts or when isOpen changes
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="relative inline-block text-left">
      <div>
        <button
          ref={buttonRef}
          type="button"
          className={`menu-toggle${isOpen ? ' opened' : ''}`}
          id="menu-toggle"
          aria-expanded={isOpen}
          onClick={toggleDropdown}
        >
          <span className="screen-reader-text">Menu</span>
          <svg
            className="icon icon-menu-toggle"
            aria-hidden="true"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
          >
            <g className="svg-menu-toggle">

                
                <path className="line line-1" d="M5 20h85v6H5z" fill='#2c2d2c'/>
                <path className="line line-2" d="M25 47h65v6H25z" fill='#2c2d2c'/>
                <path className="line line-3" d="M5 74h85v6H5z" fill='#2c2d2c'/>

            </g>
          </svg>
        </button>
      </div>

      {isOpen && (
        <div
          ref={menuRef}
          className="absolute right-[-8px] z-50 mt-[30px] w-56 rounded-xl shadow-md ring-1 ring-black ring-opacity-5 focus:outline-none"
          style={{ backgroundColor: 'var(--background)', color: 'var(--foreground)' }}
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="menu-button"
          tabIndex={-1}
        >
          <div className="flex flex-col items-end p-6" role="none">
            <DropdownLink href="/" icon={<HomeIcon />}>
              Home
            </DropdownLink>
            <DropdownLink href="/subscriptions" icon={<SubscriptionIcon />}>
              Subscriptions
            </DropdownLink>
            <DropdownLink href="/about" icon={<AboutIcon />} >
              About Us
            </DropdownLink>
            <DropdownLink href="/services" icon={<CompIcon />}>
              Services
            </DropdownLink>
            <DropdownLink href="/about/portfolio" icon={<FolderIcon />}>
              Our Works
            </DropdownLink>
            <DropdownLink href="/contact" icon={<ContactIcon />}>
              Contact Us
            </DropdownLink>
            <DropdownLink href="/blog" icon={<BlogIcon className='opacity-50' />}>
              Blog
            </DropdownLink>
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
